import React from "react";
import { Skeleton } from "@material-ui/lab";
import * as Yup from "yup";
import { Formik } from "formik";
import { uniqBy } from "lodash";
import { AutocompleteMultiple } from "../../../ui/components/AutocompleteMultiple";
import { sortHelper } from "../../../ui/helpers";
import { ListButton } from "../../../ui/components/ListButton";

const initialValues = {
  contact_ids: [],
};

export const LinkContacts = ({
  contactsOptions = [],
  linkedContacts = [],
  handleCancel,
  handleSubmit,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object({
        contact_ids: Yup.array().required("Required field"),
      })}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, handleSubmit, ...formik }) => (
        <div className="p-5">
          <h3 className="mb-10 text-center">Link Contacts</h3>
          {contactsOptions.length ? (
            <div className="">
              <AutocompleteMultiple
                name="contact_ids"
                placeholder="Contacts"
                setValue={setFieldValue}
                options={uniqBy(contactsOptions, "label").sort(sortHelper)}
                defaultValueField="value"
                defaultValue={linkedContacts.map(({ id }) => id)}
              />
              {formik.touched.contact_ids && formik.errors.contact_ids ? (
                <div className="text-danger">{formik.errors.contact_ids}</div>
              ) : null}
            </div>
          ) : (
            <div>
              <Skeleton variant="rect" width={"100%"} height={55} />
            </div>
          )}
          <div className="mt-10 d-flex justify-content-end align-items-center">
            <ListButton
              label="Cancel"
              size="large"
              onClick={handleCancel}
              boxShadow={false}
              className="mx-2"
            />
            <ListButton
              label="Save"
              size="large"
              onClick={handleSubmit}
              boxShadow={false}
            />
          </div>
        </div>
      )}
    </Formik>
  );
};
